import { api } from 'app/config/apiConfig';
import { Zone, UpdateZoneParams } from '../model/types';

export const updateZoneApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateZone: builder.mutation<Zone, UpdateZoneParams & { warehouseId: string; zoneId: string }>({
      query: ({ warehouseId, zoneId, ...payload }) => ({
        url: `/warehouses/${warehouseId}/zones/${zoneId}`,
        method: 'PUT',
        body: { ...payload, warehouseId },
      }),
      invalidatesTags: ['Zones'],
    }),
  }),
});

export const { useUpdateZoneMutation } = updateZoneApi;
